import React from 'react'
import './Recommendviedeo.css'
import Video from './video'
function RecommendViedeo() {
  return (
    <div className='recommendviedeo'>
        <h2>Recommend</h2>
        <div className='recommendvideo'>
        <Video 
        title="In this Exclusive React VIDEO training, we will be covering... ✓ Learn how to build the FULL Amazon website with FULL .."
        views="1.4K Views"
        timestamp="59 seconds ago"
        channelImage="https://randomuser.me/api/portraits/men/10.jpg"
        channel="Badsunited Sagar"
        image="https://media.graphcms.com/qNYh5gvQcyleZKzTEqHl"
        />
        <Video 
        title="reading people's assumptions about me"
        views="190K Views"
        timestamp="4 years ago"
        channelImage="https://randomuser.me/api/portraits/men/10.jpg"
        channel="Badsunited Sagar"
        image="https://media.graphcms.com/lqUQTOS4QoKI63grXTYJ"
        />
        <Video 
        title="How to use Uber Suggest Chrome extension?| UberSuggest Chrome Extension"
        views="1K Views"
        timestamp="5 days ago"
        channelImage="https://randomuser.me/api/portraits/men/10.jpg"
        channel="Badsunited Sagar"
        image="https://media.graphcms.com/aVrJ1JlvSHeyJIE60VI5"
        />
        <Video 
        title="Yoga For Anxiety and Stress"
        views="7.5M Views"
        timestamp="3 secomds ago"
        channelImage="https://randomuser.me/api/portraits/men/10.jpg"
        channel="Badsunited Sagar"
        image="https://media.graphcms.com/TlUmfJGCRAaiepkuTeGM"
        />
        

        

        <Video 
        title="A Weekend In Bangor, Wales with Virgin Trains"
        views="7.5K Views "
        timestamp="3 months ago"
        channelImage="https://randomuser.me/api/portraits/men/10.jpg"
        channel="Badsunited Sagar"
        image="https://media.graphassets.com/Xf3LufTSQKFefraHZIrG"
        />
        

        <Video 
        title="MUST Visit FLEA Market in Bangalore | Shopping | Bangalore | Karnataka Chitra Kala Parishath"
        views="1.7K Views "
        timestamp="2 months ago"
        channelImage="https://randomuser.me/api/portraits/men/10.jpg"
        channel="Badsunited Sagar"
        image="https://media.graphcms.com/YylcBrkmTGmikoNfZLzG"
        />
        

        <Video 
        title="Iftar Special Beef Cutlet | Kerala Style Snacks Recipe"
        views="1.5M Views "
        timestamp="49 days ago"
        channelImage="https://randomuser.me/api/portraits/men/10.jpg"
        channel="Badsunited Sagar"
        image="https://media.graphcms.com/4twYlR6GQBC2wEyjF244"
        />
        

        <Video 
        title="The Hooks od cloud computing"
        views="4.5K Views "
        timestamp=" 3 months ago"
        channelImage="https://randomuser.me/api/portraits/men/10.jpg"
        channel="Badsunited Sagar"
        image="https://thumbs.dreamstime.com/z/let-s-go-travel-en…mera-vacation-blue-background-let-s-117416564.jpg"
        />
        

        <Video 
        title="Building the instagram clone"
        views="1.4M Views "
        timestamp=" 7 months ago"
        channelImage="https://randomuser.me/api/portraits/men/10.jpg"
        channel="Badsunited Sagar"
        image="https://media.graphcms.com/qNYh5gvQcyleZKzTEqHl"
        />
        
        </div>
    </div>
  )
}

export default RecommendViedeo
